<!-- Auto Search Component with Api option result -->
<template>
  <div class="my-3">
    <b-row align-v="center">
      <b-col :sm="labelWidth" class="text-left">
        <label :class="validationStyle" class="mb-0 align-middle">{{label}} <span v-if="required&&label" :class="validationState?'form-valid':'form-invalid'" style="font-size: 1rem;">*</span></label>
      </b-col>
      <b-col :sm="inputWidth">
        <v-select :value="value" style="background-color: white;" :options="options" :filterable="false" :disabled='disabled' @search="onSearch" :onChange="onInput" :placeholder="placeholder" :class="autoSearchStyle">
          <template slot="no-options">
            {{$t('general.autoSearchText')}}
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <span v-for="showItem in showItems" class="px-1">{{option[showItem]}}</span>
            </div>
          </template>
          <template slot="selected-option" scope="option">
            <div class="selected d-center">
              <span v-for="showItem in showItems" class="px-1">{{option[showItem]}}</span>
            </div>
          </template>
        </v-select>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="end">
      <b-col :sm="inputWidth">
        <span class="form-invalid" v-if="validationState==false">{{errorMsg}}<br/></span>
        <!--           <span> {{validatorObject}} </br> {{validationState}}</span>       
 --><span style="display: none;">{{getRuleByField}}{{validatorObject}}</span>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import vSelect from 'vue-select'
import { API, APIList } from '@/api'
import { required } from 'vuelidate/lib/validators'
import FITValidationBus from './FITValidationBus';

var searchWatchDog;
export default {
  name: 'FITAutoSearch',
  components: { vSelect },
  props: {
    label: String,
    width: Number,
    disabled: Boolean,
    placeholder: String,

    dest: {
      type: String,
      required: true
    },

    paras: {
      type: Array,
      required: true
    },

    showItems: {
      type: Array,
      required: true,
    },
    value: [
      Object,
      String
    ],
    resultKey: {
      type: String,
      default: null
    },
    rule: { type: Object, default: function() { return {} } },
    field: String,
    vuexObject: { type: String, default: "default" },
    vuexModule: { type: String, default: "Validation" },
    vuexMutation: { type: String, default: "setValidationResult" },

  },
  data() {
    return {
      inputWidth: this.width,
      options: [],
      api: new APIList(),
      fieldInput: this.value,
      vuexValidator: false,
      firstCheck: true,
      emptyObj: {
        ID: null
      }
    }
  },
  validations() {
    if (this.required == true) {
      return {
        fieldInput: { required },
      }
    } else {
      return {
        fieldInput: {}
      }
    }
  },
  watch: {
    fieldInput: {
      deep: true,
      handler(val) {
        // console.log(val);
        this.$emit('validation', this.validationState);
        if (!val) {
          this.$emit('input', this.emptyObj);
          this.$emit('resultKeyOutput', this.emptyObj);
          return;
          // if (this.resultKey) {
          // } else {
          //   this.$emit('input',this.emptyObj );
          // }
        }
        if (this.resultKey) {
          this.$emit('resultKeyOutput', val[this.resultKey]);
        } else {
          this.$emit('input', val);
        }
      }
    },
    value: {
      handler(val) {
        this.onInput(val);
      },
      immediate: true
    }
  },

  created() {
    var paras = this.paras;
    for (var i = paras.length - 1; i >= 0; i--) {
      if ((paras[i].key == 'ID') && (paras[i].value)) {
        this.getOptionByID(this);
      }
    }
    // if((this.placeholder)&&(this.showItems)){
    //   this.emptyObj[this.showItems[0]] = this.placeholder;
    // }
  },
  mounted() {
    this.labelCheck(this.label);
    if (this.fieldInput) {
      this.$v.fieldInput.$touch();
    }
    // onListen Reset 
    FITValidationBus.$on('reset', (value) => {
      if (value) {
        // console.log("onEmit");
        if (this.$v) {
          this.$nextTick(() => { this.$v.$reset() })
        }
      }
    });

    // onListen dirty 
    FITValidationBus.$on('dirty', (value) => {
      if (value) {
        if (value == this.vuexObject) {
          // console.log("onDirty");
          this.$nextTick(() => { this.$v.fieldInput.$touch() });
          this.$emit('validation', this.validationState);

        }
      }
    });

    // Initial Dirty
    this.$nextTick(() => { this.$v.$reset() })
  },

  computed: {
    getRuleByField() {
      let rules = this.$store.getters[`${this.vuexModule}/getRuleByField`];
      let result = rules(this.field);
      if (Object.keys(result).length > 0) {
        this.vuexValidator = true;
        // console.log(result);
      } else {
        this.vuexValidator = false;
      }
      return result;
    },
    required() {
      if (this.vuexValidator) {
        return true;
      }

      if (this.rule.required == true) {
        return true;
      } else {
        return false;
      }
    },
    getValidationFinalCheck() {
      if (!this.vuexModule) {
        return false;
      }
      return this.$store.getters[`${this.vuexModule}/getValidationFinalCheck`];
    },
    errorMsg() {
      return this.$t('validation.errorMsg.required');
    },
    validatorObject() {
      return this.$v.fieldInput;
    },
    validationState() {
      if ((!this.required) || (this.disabled)) {
        return null;
      }
      if (this.getValidationFinalCheck) {
        this.$v.fieldInput.$touch();
      }
      // Valdiation State Check
      let dirty = this.$v.fieldInput.$dirty;
      let invalid = this.$v.fieldInput.$invalid;
      let state = null;
      if (!dirty) {
        state = null;
      } else {
        if (invalid) {
          state = false;
        } else {
          if (!this.fieldInput) {
            state = null;
          } else {
            state = true;
            // InitialState Override
            // console.log(this.fieldInput);
            // Initial Value
            switch (this.fieldInput.ID) {
              case 0:
              case -1:
              case null:
                if (this.firstCheck == true) {
                  state = null;
                  // this.fieldInput = this.emptyObj;
                  this.$nextTick(() => { this.$v.$reset() });
                  this.firstCheck = false;
                } else {
                  state = false;
                }
                break;
            }
          }
        }
      }
      // Update to Vuex
      if (this.field) {
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          object: this.vuexObject,
          field: this.field,
          result: state,
        });
      }
      return state;
    },
    validationStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'form-valid'; }
      if (this.validationState == false) { return 'form-invalid'; }
    },
    autoSearchStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'autoSearchFormValid'; }
      if (this.validationState == false) { return 'autoSearchFormInValid'; }
    },
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },

  methods: {

    onSearch(search, loading) {
      if (search) {
        this.search(search, this);
      }
    },
    search(searchString, vm) {
      clearTimeout(searchWatchDog);
      searchWatchDog = setTimeout(function() {
        var parameters = [];
        parameters[0] = vm.paras[0];
        parameters.push({ key: 'search', value: searchString });

        vm.api.autoSearch(vm.dest, parameters,
          (json) => {
            vm.options = json.data.list;
          },
          (error) => {
            console.error(error);
          })
      }, 500);
    },
    getOptionByID(vm) {
      vm.api.autoSearch(vm.dest, vm.paras, (json) => {
          vm.initOption = json.data.list[0];
        },
        (error) => {
          console.error(error);
        })

    },
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    onInput(event) {
      // console.debug(event);
      // if (!event) {
      //   this.$emit('input', "");
      //   return;
      // }
      // if (this.resultKey) {
      //   this.$emit('resultKeyOutput', event[this.resultKey]);
      // } else {
      //   this.$emit('input', event);
      // }

      if (!event) {
        this.$v.fieldInput.$model = this.emptyObj;
        return;
      }
      this.$v.fieldInput.$model = event;

      // if (Object.keys(event).length > 0) {
      //   let ID = parseInt(event.ID);
      //   if (ID <= 0) {
      //     this.$v.fieldInput.$model = this.emptyObj;
      //   }
      // }
    },
  }
}

</script>
<style type="text/css">
.autoSearchFormValid .dropdown-toggle {
  border: 1px solid #4dbd74 !important;
}

.autoSearchFormInValid .dropdown-toggle {
  border: 1px solid #f86c6b !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Form/FITAutoSearch.vue